window.productDetailsResourcesHandler = () => {
  document.addEventListener('DOMContentLoaded', () => {
    switchTabs();
    changeImageAfterHoverOnDot();
    dimensionsTabEvents();
    toggleShowModalResources();
    downloadAllFiles();
    setImageTabActive();
    tabsSliderEvent();
    collapseMultiplesEvents();
  });

  window.addEventListener('scroll', () => {
    setImageTabActive();
  })

  // Set image tab active depends on the user position
  const setImageTabActive = (tab) => {
    const resourcesModal = document.querySelector('.jsModalSlideResources');
    const modalNav = resourcesModal.querySelector('.jsProductResourcesNav');
    const navItems = modalNav.querySelectorAll('.jsProductResourcesNavItem');
    const gallerySection = document.querySelector('.jsProductGallery');
    const gallerySectionHeight = gallerySection.clientHeight;
    const galleryPosition = gallerySection.getBoundingClientRect().top;
    let activeTab = (galleryPosition > -gallerySectionHeight) ? 'images' : navItems[0].id;
    if (tab) {
      activeTab = tab;
    }
    // Set active tab id for query parameter
    window.activeTabId = activeTab;

    // Set active tab in resources modal
    navItems.forEach(item => item.id === activeTab && item.click());
  }

  // Switch tabs
  const switchTabs = () => {
    const navTabs = document.querySelectorAll('.jsProductResourcesNavItem');
    const tabContent = document.querySelectorAll('.jsProductResourcesListTab');

    navTabs.forEach((navTab, index) => {
      navTab.addEventListener('click', (e) => {

        if (document.querySelector('.jsModalSlideResources').classList.contains('active')) {
          // Set query parameter
          setParameterByName('tab', navTab.id);
        }

        navTabs.forEach((navTab, tabIndex) => {
          tabIndex === index ? navTab.classList.add('active') : navTab.classList.remove('active');
        });

        tabContent.forEach((content, contentIndex) => {
          contentIndex === index ? content.classList.add('active') : content.classList.remove('active');
        });
      });
    });
  };

  // Item different views (dots)
  const changeImageAfterHoverOnDot = function () {
    $(document).ready(function () {
      const technicalSpecBoxes = $('.jsProductTechSpecBox');

      const boxHandler = function (scope, group, box) {
        const imageId = $(scope).attr('data-id');
        const boxContainer = $(scope).closest(technicalSpecBoxes);

        boxContainer.find('.jsProductTechSpecBoxGroupImg').css('display', group);
        boxContainer.find('.jsProductTechSpecBoxGroupName').css('display', group);
        boxContainer.find('.jsProductTechSpecBoxImg[data-id=' + imageId + ']').css('display', box);
        boxContainer.find('.jsProductTechSpecBoxName[data-id=' + imageId + ']').css('display', box);
      };

      $('.jsProductTechSpecBoxDot').each(function () {
        // Hide images, materials name
        $(this).parents(technicalSpecBoxes)
          .find('.jsProductTechSpecBoxName').hide();

        $(this).on('mouseenter', function () {
          boxHandler(this, 'none', 'flex');
        });

        $(this).on('mouseleave', function () {
          boxHandler(this, 'flex', 'none');
        });
      });
    });
  };

  // Dimensions
  const dimensionsTabEvents = function () {
    // Dimensions modal
    $('.jsProductResourcesDimensions').on('click', function () {
      const dimensionsModal = $('.jsModalProductTechSpecDimensions');
      const ajaxData = $(this).data('block-id');
      dimensionsModal.addClass('active');

      $.ajax({
        type: 'GET',
        url: '/products/ajax/dimensions/' + ajaxData + '/',
        success: function (data) {
          dimensionsModal.find('.jsModalInfoContent').html($(data.content));
          const sliderDimensions = $('.jsProductResourcesDimensionsModal');
          const currentSlide = sliderDimensions.find('div[data-number]').data('number');
          sliderDimensions.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            swipe: false,
            fade: true,
            infinite: false,
            useTransform: true,
            cssEase: 'linear',
            initialSlide: parseInt(currentSlide),
          });
          var ref;
          window.renderProgressiveImages();
          if ((ref = window.lazyLoad) != null) {
            ref.update();
          }
        },
        error: (data) => {
          console.error(data)
        },
        headers: {
          'X-CSRFToken': getCookie('csrftoken')
        }
      });
    });
  };

  // Toggle show modal
  const toggleShowModalResources = () => {
    const showModalBtn = document.querySelector('.jsModalResourcesBtn');
    const openResourcesModalButtons = document.querySelectorAll('.jsShowResourcesModalButton');
    const modal = document.querySelector('.jsModalSlideResources');
    const modalOverlay = document.querySelector('.jsModalSlideResourcesOverlay');

    const openModal = (sectionName) => {
      modal.classList.add('active');
      modalOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      setParameterByName('tab', sectionName);
    };

    openResourcesModalButtons.forEach(button => {
      button.addEventListener('click', () => {
        const sectionName = button.dataset.sectionName;
        button.classList.add('resources__nav__item-product-page-active');
        setImageTabActive(sectionName);
        openModal(sectionName);
      });
    });

    if (showModalBtn) {
      showModalBtn.addEventListener('click', () => {
        setImageTabActive();
        openModal(window.activeTabId);
      });
    }
  };


  // Download all files
  const downloadAllFiles = () => {
    window.addEventListener('click', (e) => {
      const eventCategory = null;
      const isBtnClicked = e.target.classList.contains('jsProductDownloadButton');

      isBtnClicked && trackEvent(eventCategory, 'download resource', null, true)
    })
  };

  // Tabs slider in navigation
  const tabsSliderEvent = () => {
    const nav = document.querySelector('.jsProductResourcesNav');
    const navContainer = document.querySelector('.jsProductResourcesNavContainer');
    const navWidth = nav.offsetWidth;
    const navContainerWidth = navContainer.offsetWidth;
    let scrolledDistance = 0;
    let isScrollingLeft = true;
    let flag = true;
    let intervalID = null;
    let scrollPos = 0;

    function intervalManager(flag, animate, time, directionLeft) {
      if (flag)
        intervalID = setInterval(animate, time, directionLeft);
      else
        clearInterval(intervalID);
    }

    const animate = () => {
      navContainer.scrollTo({
        top: 0,
        left: scrolledDistance,
        behavior: 'smooth',
      })

      if (flag) {
        (navContainer.scrollLeft + 9 < navWidth - navContainerWidth) ? scrolledDistance++ : (flag = !flag)
      } else {
        (navContainer.scrollLeft > 0) ? scrolledDistance-- : (flag = !flag)
      }
    };

    intervalManager(true, animate, 100, isScrollingLeft)

    // stop scrolling when hover on navigation
    navContainer.addEventListener('mouseover', (e) => {
      intervalManager(false)
    });

    // start scrolling from left position
    navContainer.addEventListener('mouseup', (e) => {
      const leftScrollPosition = navContainer.scrollLeft;

      scrolledDistance = leftScrollPosition;

      if (navContainer.scrollLeft > scrollPos) {
        flag = true;
      } else {
        flag = false;
      }
      scrollPos = navContainer.scrollLeft;
    });

    // start scrolling when end hover on navigation
    navContainer.addEventListener('mouseout', (e) => {
      intervalManager(true, animate, 100, isScrollingLeft)
    });
  };

  // Collapse multiples
  const collapseMultiplesEvents = () => {
    const lists = document.querySelectorAll('.jsMultipleList');

    lists.forEach(list => {
      const items = list.querySelectorAll('.jsMultipleListItem');

      items.forEach((item, index) => {
        const name = item.querySelector('.jsMultipleItemName');
        const boxes = item.querySelector('.jsMultipleItemBoxes');

        name.addEventListener('click', (e) => {
          item.classList.toggle('active');
          item.classList.contains('active') ? slideDown(boxes, 300) : slideUp(boxes, 300);
        });
      });
    });
  };
};
